import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import countrySlice from "../features/country/countrySlice";
import userSlice from "../features/user/userSlice";
import drawerSlice from "../components/drawer/drawerSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import citySlice from "../features/city/citySlice";
import stateSlice from "../features/state/stateSlice";
import lineSlice from "../features/line/lineSlice";
import newportSlice from "../features/newport/newportSlice";
import agentSlice from "../features/agent/agentSlice";
import shippingMovementsSlice from "../features/shippingmovements/shippingMovementsSlice";
import shippingMovementsListSlice from "../features/shippingmovementsList/shippingMovementsListSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import vesselsExportLoadingSlice from "../features/vesselsexportloading/vesselsExportLoadingSlice";
import containerImportDischargeSlice from "../features/containerimportdischarge/containerImportDischargeSlice";
import portdataimportSlice from "../features/portdataimport/portdataimportSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    dialog: dialogSlice,
    drawer: drawerSlice,
    pagination: paginationSlice,
    country: countrySlice,
    city: citySlice,
    state: stateSlice,
    user: userSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    line: lineSlice,
    newport: newportSlice,
    agent: agentSlice,
    shippingMovements: shippingMovementsSlice,
    shippingMovementslist: shippingMovementsListSlice,
    vesselsExportLoading: vesselsExportLoadingSlice,
    containerImportDischarge: containerImportDischargeSlice,
    portdata: portdataimportSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
